webpackJsonp([12],{

/***/ 1245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoxSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Box = function (_Component) {
  _inherits(Box, _Component);

  function Box() {
    _classCallCheck(this, Box);

    return _possibleConstructorReturn(this, (Box.__proto__ || Object.getPrototypeOf(Box)).apply(this, arguments));
  }

  _createClass(Box, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.shadow, this.props.shadow), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.hidden, this.props.hidden), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          shadow = _props.shadow,
          restProps = _objectWithoutProperties(_props, ['children', 'shadow']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        this.props.children
      );
    }
  }]);

  return Box;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Box.defaultProps = {
  className: '',
  shadow: false,
  hidden: false
};


var BoxSection = function BoxSection(_ref) {
  var className = _ref.className,
      children = _ref.children,
      disabled = _ref.disabled,
      disabledContent = _ref.disabledContent,
      restProps = _objectWithoutProperties(_ref, ['className', 'children', 'disabled', 'disabledContent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.section, className) }),
    children,
    disabled && _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.disabledOverlay
    }, void 0, disabledContent)
  );
};

BoxSection.defaultProps = {
  className: '',
  disabled: false,
  disabledContent: null
};

/* harmony default export */ __webpack_exports__["b"] = (Box);


/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_1Ob7a","shadow":"_3NCC3","hidden":"_170VA","section":"UNjnV","disabledOverlay":"_2jdoD"};

/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MastheadOverlap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Masthead = function (_Component) {
  _inherits(Masthead, _Component);

  function Masthead() {
    _classCallCheck(this, Masthead);

    return _possibleConstructorReturn(this, (Masthead.__proto__ || Object.getPrototypeOf(Masthead)).apply(this, arguments));
  }

  _createClass(Masthead, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.overlap, this.props.overlap), _defineProperty({}, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.plain, this.props.plain), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          overlap = _props.overlap,
          plain = _props.plain,
          restProps = _objectWithoutProperties(_props, ['children', 'overlap', 'plain']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'section',
        _extends({}, restProps, { className: this.getClassName() }),
        children
      );
    }
  }]);

  return Masthead;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Masthead.defaultProps = {
  className: '',
  overlap: false,
  plain: false
};


var MastheadOverlap = function MastheadOverlap(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['className', 'children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.overlapEl, className) }),
    children
  );
};

MastheadOverlap.defaultProps = {
  className: ''
};

/* harmony default export */ __webpack_exports__["b"] = (Masthead);


/***/ }),

/***/ 1249:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3fRR8","overlap":"_3MekN","plain":"_2QEMQ","overlapEl":"_3opO9"};

/***/ }),

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_Spinner__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_3_components_Spinner__["a" /* default */], {
  width: '30',
  height: '30',
  color: '#fff'
});

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'getElement',
    value: function getElement() {
      return 'href' in this.props ? __WEBPACK_IMPORTED_MODULE_4_components_Link__["a" /* default */] : 'button';
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var _classnames;

      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.root, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a[this.props.theme], __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a[this.props.size], (_classnames = {}, _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.rounded, this.props.rounded), _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.disabled, this.props.disabled), _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.loading, this.props.loading), _classnames), this.props.className);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          theme = _props.theme,
          size = _props.size,
          rounded = _props.rounded,
          loading = _props.loading,
          restProps = _objectWithoutProperties(_props, ['className', 'children', 'theme', 'size', 'rounded', 'loading']);

      var Element = this.getElement();

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Element,
        _extends({}, restProps, {
          disabled: this.props.disabled || this.props.loading,
          className: this.getClassName()
        }),
        loading && _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.spinnerWrapper
        }, void 0, _ref),
        _jsx('span', {
          className: __WEBPACK_IMPORTED_MODULE_5__styles_css___default.a.content
        }, void 0, children)
      );
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Button.defaultProps = {
  className: '',
  theme: 'primary',
  size: 'medium',
  rounded: false,
  disabled: false,
  loading: false
};


/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),

/***/ 1251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR_CLASS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ERROR_CLASS = '__input-validation-error';

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input() {
    _classCallCheck(this, Input);

    return _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).apply(this, arguments));
  }

  _createClass(Input, [{
    key: 'getClassName',
    value: function getClassName() {
      var _classnames;

      var meta = this.props.meta;


      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, (_classnames = {}, _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.focused, meta.active), _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.faulty, meta.touched && meta.error), _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.required, this.props.required), _defineProperty(_classnames, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.disabled, this.props.disabled), _classnames), this.props.className);
    }
  }, {
    key: 'getInputElement',
    value: function getInputElement() {
      var type = this.props.type;

      if (typeof type === 'string') {
        return type === 'textarea' ? 'textarea' : 'input';
      }
      return type;
    }
  }, {
    key: 'getLabelElement',
    value: function getLabelElement() {
      return this.props.label ? 'label' : 'div';
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          label = _props.label,
          description = _props.description,
          input = _props.input,
          meta = _props.meta,
          type = _props.type,
          restProps = _objectWithoutProperties(_props, ['className', 'label', 'description', 'input', 'meta', 'type']);

      var InputElement = this.getInputElement();
      var LabelElement = this.getLabelElement();

      return _jsx(LabelElement, {
        className: this.getClassName()
      }, void 0, label && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.label
      }, void 0, label), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputElement, _extends({
        type: typeof type === 'string' ? type : undefined
      }, input, restProps)), description && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.description
      }, void 0, description), meta.touched && meta.error && _jsx('div', {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.error, ERROR_CLASS)
      }, void 0, meta.error));
    }
  }]);

  return Input;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Input.defaultProps = {
  className: '',
  label: null,
  description: null,
  input: {},
  meta: {}
};


/* harmony default export */ __webpack_exports__["b"] = (Input);

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_3dLYL","primary":"_1YvH8","secondary":"_6JJ0o","small":"_3zJyZ","medium":"_2qrUQ","large":"_15GK-","full":"_3VCHy","rounded":"_2v4Pb","content":"_3CV4w","loading":"eWg_z","spinnerWrapper":"_3Ug5r"};

/***/ }),

/***/ 1254:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_2nkYL","disabled":"_1XBsJ","label":"_3vdd8","required":"_1rWjO","description":"_1OHUc","error":"_1_aqS"};

/***/ }),

/***/ 1261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FormFieldset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormChoiceGroup; });
/* unused harmony export FormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }







var Form = function Form(_ref) {
  var className = _ref.className,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['className', 'children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'form',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, className) }),
    children
  );
};

Form.defaultProps = {
  className: ''
};

var FormFieldset = function FormFieldset(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      restProps = _objectWithoutProperties(_ref2, ['className', 'children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'fieldset',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.fieldset, className) }),
    children
  );
};




FormFieldset.defaultProps = {
  className: ''
};

var FormChoiceGroup = function FormChoiceGroup(_ref3) {
  var className = _ref3.className,
      label = _ref3.label,
      children = _ref3.children,
      restProps = _objectWithoutProperties(_ref3, ['className', 'label', 'children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    _extends({}, restProps, { className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.choiceGroup, className) }),
    label && _jsx('span', {
      className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.label
    }, void 0, label),
    _jsx('div', {
      className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.choices
    }, void 0, children)
  );
};




FormChoiceGroup.defaultProps = {
  className: '',
  label: ''
};

var FormError = function FormError(_ref4) {
  var meta = _ref4.meta;
  return _jsx('div', {}, void 0, meta.touched && meta.error && _jsx('div', {
    className: __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.error
  }, void 0, meta.error));
};

/* harmony default export */ __webpack_exports__["c"] = (Form);

/***/ }),

/***/ 1264:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_29wDO","fieldset":"_1CaOG","choiceGroup":"_1E2El","choices":"C4guS","label":"qBfYa","error":"AbtIU"};

/***/ }),

/***/ 1289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SUCCESS_CLASS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__styles_css__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var SUCCESS_CLASS = '__callout_success';

var Callout = function (_Component) {
  _inherits(Callout, _Component);

  function Callout() {
    _classCallCheck(this, Callout);

    return _possibleConstructorReturn(this, (Callout.__proto__ || Object.getPrototypeOf(Callout)).apply(this, arguments));
  }

  _createClass(Callout, [{
    key: 'getClassName',
    value: function getClassName() {
      return __WEBPACK_IMPORTED_MODULE_2_classnames___default()(__WEBPACK_IMPORTED_MODULE_3__styles_css___default.a.root, __WEBPACK_IMPORTED_MODULE_3__styles_css___default.a[this.props.type], this.props.className, _defineProperty({}, SUCCESS_CLASS, this.props.type === 'success'));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          type = _props.type,
          restProps = _objectWithoutProperties(_props, ['children', 'type']);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({}, restProps, { className: this.getClassName() }),
        children
      );
    }
  }]);

  return Callout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Callout.defaultProps = {
  className: ''
};


/* harmony default export */ __webpack_exports__["b"] = (Callout);

/***/ }),

/***/ 1442:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_2KUEm","error":"_1OTha","warning":"_1WCfr","success":"qq18h"};

/***/ }),

/***/ 1459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return required; });
var required = function required(value) {
  return value ? undefined : 'This field is required.';
};

/***/ }),

/***/ 1588:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return initialState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(112);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])({
  fetched: false,
  initialValues: {}
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["b" /* handleActions */])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */], {
  SET: function SET(state, _ref) {
    var payload = _ref.payload;
    return state.merge(payload);
  },
  SET_INITIAL_VALUES: function SET_INITIAL_VALUES(state, _ref2) {
    var payload = _ref2.payload;
    return state.mergeIn(['initialValues'], payload).set('fetched', true);
  },
  UPDATE_INITIAL_VALUES: function UPDATE_INITIAL_VALUES(state, _ref3) {
    var payload = _ref3.payload;
    return state.mergeIn(['initialValues'], payload);
  }
}), initialState));

/***/ }),

/***/ 1589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_actions__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(112);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var actions = Object(__WEBPACK_IMPORTED_MODULE_0_redux_actions__["a" /* createActions */])(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* NAME */], {
  SET: undefined,
  SET_INITIAL_VALUES: undefined,
  INITIALIZE: undefined,
  UPDATE_INITIAL_VALUES: undefined,
  SUBMIT: undefined
}));

/* harmony default export */ __webpack_exports__["a"] = (actions[__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* NAME */]]);

/***/ }),

/***/ 1649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onSubmit */
/* harmony export (immutable) */ __webpack_exports__["a"] = _callee;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_first_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_immutable__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_views_App_actions__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_views_App_selectors__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_views_Home_constants__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(1589);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _marked = /*#__PURE__*/regeneratorRuntime.mark(onSubmit),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(_callee);














function onSubmit(_ref) {
  var payload = _ref.payload;
  var error, message;
  return regeneratorRuntime.wrap(function onSubmit$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form_immutable__["startAsyncValidation"])(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* NAME */]));

        case 2:
          _context.next = 4;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(__WEBPACK_IMPORTED_MODULE_3_views_App_actions__["a" /* default */].login(_extends({}, payload)));

        case 4:
          _context.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["g" /* take */])([__WEBPACK_IMPORTED_MODULE_3_views_App_actions__["a" /* default */].loginSuccess.toString(), __WEBPACK_IMPORTED_MODULE_3_views_App_actions__["a" /* default */].loginError.toString()]);

        case 6:
          error = _context.sent;
          message = error.payload;
          _context.next = 10;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_2_redux_form_immutable__["stopAsyncValidation"])(__WEBPACK_IMPORTED_MODULE_7__constants__["a" /* NAME */], message ? { username: message } : null));

        case 10:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function _callee() {
  var account;
  return regeneratorRuntime.wrap(function _callee$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["f" /* select */])(__WEBPACK_IMPORTED_MODULE_4_views_App_selectors__["a" /* accountSelector */]);

        case 2:
          account = _context2.sent;

          if (!account) {
            _context2.next = 6;
            break;
          }

          _context2.next = 6;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["d" /* put */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux_first_router__["redirect"])(Object(__WEBPACK_IMPORTED_MODULE_6_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_5_views_Home_constants__["a" /* NAME */])));

        case 6:
          _context2.next = 8;
          return Object(__WEBPACK_IMPORTED_MODULE_1_redux_saga_effects__["h" /* takeEvery */])(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].submit.toString(), onSubmit);

        case 8:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ 1650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stateSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_selectors__ = __webpack_require__(147);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };









var stateSelector = function stateSelector(state) {
  return state.get(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* NAME */]) || __WEBPACK_IMPORTED_MODULE_3__reducer__["b" /* initialState */];
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(stateSelector, __WEBPACK_IMPORTED_MODULE_1_utilities_routes__["b" /* locationSelector */], __WEBPACK_IMPORTED_MODULE_4__App_selectors__["a" /* accountSelector */], function (state, location, account) {
  return _extends({
    location: location,
    account: account
  }, state.toJS());
}));

/***/ }),

/***/ 1651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"_2zaF7"};

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_djedi_react__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_djedi_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_djedi_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_immutable__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_redux_form_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_state_reducers__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_state_sagas__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_layouts_Page__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_layouts_Masthead__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_layouts_Container__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_layouts_Form__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_layouts_Box__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Spinner__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_Callout__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_Input__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_Button__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_Link__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_utilities_validators__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_utilities_routes__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_views_Signup_constants__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_views_PasswordReset_constants__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__constants__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__reducer__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__actions__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__sagas__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__selectors__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_css__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__styles_css__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _templateObject = _taggedTemplateLiteral(['\n                # Logga in\n\n\n              '], ['\n                # Logga in\n\n\n              ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


































var Message = function Message(_ref) {
  var message = _ref.message;

  switch (message) {
    case 'invite':
      return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, 'F\xF6r att se inbjudan beh\xF6ver du ett konto hos friendtivity.', ' ', _jsx(__WEBPACK_IMPORTED_MODULE_16_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_18_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_19_views_Signup_constants__["c" /* PARENT_SIGNUP */])
      }, void 0, 'Registrera dig'), ' eller logga in.');
    case 'activity':
      return _jsx(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, {}, void 0, 'F\xF6r att skapa en aktivitet beh\xF6ver du ett konto hos friendtivity.', ' ', _jsx(__WEBPACK_IMPORTED_MODULE_16_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_18_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_19_views_Signup_constants__["c" /* PARENT_SIGNUP */])
      }, void 0, 'Registrera dig'), ' eller logga in.');
    default:
      return  false ? 'Unknown message: ' + message : null;
  }
};

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_12_components_Spinner__["a" /* default */], {
  width: '45',
  height: '45',
  center: true
}, 'spinner');

var LoginPage = function (_Component) {
  _inherits(LoginPage, _Component);

  function LoginPage() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, LoginPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = LoginPage.__proto__ || Object.getPrototypeOf(LoginPage)).call.apply(_ref2, [this].concat(args))), _this), _this.onSubmit = function (values) {
      return _this.props.dispatch(__WEBPACK_IMPORTED_MODULE_23__actions__["a" /* default */].submit(values.toJS()));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoginPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers__["a" /* addReducer */])(__WEBPACK_IMPORTED_MODULE_21__constants__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_22__reducer__["a" /* default */]);
      Object(__WEBPACK_IMPORTED_MODULE_6_state_sagas__["a" /* addSaga */])(__WEBPACK_IMPORTED_MODULE_21__constants__["a" /* NAME */], __WEBPACK_IMPORTED_MODULE_24__sagas__["a" /* default */]);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      Object(__WEBPACK_IMPORTED_MODULE_5_state_reducers__["c" /* removeReducer */])(__WEBPACK_IMPORTED_MODULE_21__constants__["a" /* NAME */]);
      Object(__WEBPACK_IMPORTED_MODULE_6_state_sagas__["b" /* removeSaga */])(__WEBPACK_IMPORTED_MODULE_21__constants__["a" /* NAME */]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref3 = this.props.location.query || {},
          message = _ref3.message,
          next = _ref3.next;

      var account = this.props.account;

      /*
          Show spinner if user visits a page that requires login but the status
          of the account is unknown. This prevents login form from flashing
          before user account status has been fetched
          */

      if (next && account === false) {
        return _ref4;
      }

      return _jsx(__WEBPACK_IMPORTED_MODULE_7_layouts_Page__["a" /* default */]
      // {...this.props.meta.toJS()}
      , {
        className: __WEBPACK_IMPORTED_MODULE_26__styles_css___default.a.root,
        title: 'Logga in'
      }, 'page', _jsx(__WEBPACK_IMPORTED_MODULE_8_layouts_Masthead__["b" /* default */], {
        overlap: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Container__["a" /* default */], {
        size: 'medium'
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_djedi_react__["Node"], {
        uri: 'login/text1.md'
      }, void 0, Object(__WEBPACK_IMPORTED_MODULE_2_djedi_react__["md"])(_templateObject)))), _jsx(__WEBPACK_IMPORTED_MODULE_8_layouts_Masthead__["a" /* MastheadOverlap */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_9_layouts_Container__["a" /* default */], {
        size: 'medium'
      }, void 0, _jsx('form', {
        onSubmit: this.props.handleSubmit(this.onSubmit)
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11_layouts_Box__["b" /* default */], {
        shadow: true
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_11_layouts_Box__["a" /* BoxSection */], {}, void 0, message && _jsx(__WEBPACK_IMPORTED_MODULE_13_components_Callout__["b" /* default */], {
        type: 'error'
      }, void 0, _jsx(Message, {
        message: message
      })), _jsx(__WEBPACK_IMPORTED_MODULE_10_layouts_Form__["b" /* FormFieldset */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3_redux_form_immutable__["Field"], {
        component: __WEBPACK_IMPORTED_MODULE_14_components_Input__["b" /* default */],
        label: 'Din e-postadress',
        type: 'email',
        name: 'username',
        validate: [__WEBPACK_IMPORTED_MODULE_17_utilities_validators__["a" /* required */]]
      }), _jsx(__WEBPACK_IMPORTED_MODULE_3_redux_form_immutable__["Field"], {
        component: __WEBPACK_IMPORTED_MODULE_14_components_Input__["b" /* default */],
        label: 'Ange l\xF6senord',
        type: 'password',
        name: 'password',
        validate: [__WEBPACK_IMPORTED_MODULE_17_utilities_validators__["a" /* required */]]
      })), _jsx('div', {
        style: {
          textAlign: 'center'
        }
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_15_components_Button__["a" /* default */], {
        loading: this.props.asyncValidating,
        rounded: true
      }, void 0, 'Logga in'), _jsx('p', {}, void 0, 'Inget konto?', ' ', _jsx(__WEBPACK_IMPORTED_MODULE_16_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_18_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_19_views_Signup_constants__["c" /* PARENT_SIGNUP */])
      }, void 0, 'Registrera dig'), '.'), _jsx('p', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_16_components_Link__["a" /* default */], {
        href: Object(__WEBPACK_IMPORTED_MODULE_18_utilities_routes__["c" /* reverse */])(__WEBPACK_IMPORTED_MODULE_20_views_PasswordReset_constants__["b" /* PASSWORD_RESET_REQUEST */])
      }, void 0, 'Har du gl\xF6mt ditt l\xF6senord?')))))))));
    }
  }]);

  return LoginPage;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LoginPage.defaultProps = {
  asyncValidating: false,
  account: false
};


/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["connect"])(__WEBPACK_IMPORTED_MODULE_25__selectors__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_immutable__["reduxForm"])({
  form: __WEBPACK_IMPORTED_MODULE_21__constants__["a" /* NAME */],
  onChange: function onChange(values, dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3_redux_form_immutable__["stopAsyncValidation"])(__WEBPACK_IMPORTED_MODULE_21__constants__["a" /* NAME */], { clear: true }));
  }
})(LoginPage)));

/***/ })

});


// WEBPACK FOOTER //
// views/Login-index.b8ed72204ba637dad2eb.js